import React from 'react'
import ProductList from '../../components/AdminSideComponents/DashBoardProduct/ProductList'

const Product = () => {
  return (
    <div className='bg-[#EEF3F7] p-6 '>
      <ProductList />
    </div>
  )
}

export default Product